import React, { useContext } from 'react';

/**
 * This context is an abstraction of the original Passport Session Context which contains
 * only the elements which are common across all projects to allow sha
 *
 * @readonly
 * @enum {cosaNavButtonOperation}
 */
const ProviderVariantContext = React.createContext(null);
export default ProviderVariantContext;
export const useProviderVariantContext = () =>  useContext(ProviderVariantContext) ;